module.exports = __webpack_public_path__ + "static/media/facebook-login-logo.71acf596.png";